import formatMaskedPhone from "./formatMaskedPhone";
var getPhoneValues = function (numbers) {
    var fieldValues = { MOBILE: "N/A", BUSINESS: "N/A", HOME: "N/A" };
    numbers.forEach(function (phone) {
        if (phone["cipher.contactNumber"]) {
            fieldValues[phone.contactType] = formatMaskedPhone(phone["cipher.contactNumber"]);
        }
    });
    return fieldValues;
};
export default getPhoneValues;
